import { useCallback } from "react";
import { Config } from "src/Utils/ConfigService/LoadConfig";
import { v1 } from "src/Utils/ApiVersions";
import { logger } from "src/Utils/LoggerService/LoggerService";
import { usePutRequest } from "src/Utils/Hooks/ApiWrappers/usePutRequest";

interface ITransferOwnership {
  userId: string;
  clinicId: string;
}

/**
 * Transfers clinic ownership to another registered member. Owner-only action.
 * The current owner is demoted to Admin by the backend once the transfer succeeds.
 * PUT /clinic/{clinicId}/transfer-ownership with the target user's id (GUID) as the body.
 */
export const useTransferOwnership = () => {
  const { putRequest, reqestError, reqestLoading, reqestResponse } = usePutRequest();

  const transferOwnership = useCallback((request: ITransferOwnership) => {
    const baseUrl = Config.GetConfigData().serviceUrl;
    const requestUrl = `${baseUrl}api/${v1}/clinic/${request.clinicId}/transfer-ownership`;

    logger.logInformation(`Request to transfer ownership to user ${request.userId} for clinic id: ${request.clinicId} was made`);

    putRequest<string>(JSON.stringify(request.userId), requestUrl);
  }, [putRequest]);

  return {
    transferOwnership,
    transferStatus: !!reqestResponse,
    transferError: reqestError,
    transferLoading: reqestLoading,
  };
}
